const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/liho/eCheckin/sections/KontaktPerson.tsx';
import * as React from 'react';
import { forwardRef, useEffect, useState } from 'react';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import textMap from '../translations';
import { ECheckinSectionProps, FieldPathModifier } from 'App/components/eCheckin/types';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import CIS4mSingleCheckbox from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import _ from 'lodash';
import KontaktPersonBlock from 'App/config/liho/eCheckin/sections/components/KontaktPersonBlock';
import { CIS4mBlock } from '@cistec/common_web/modules/CIS4m/components/CIS4mBlock';
import { actionRemoveFromCIS4mDataObject } from '@cistec/common_web/modules/CIS4m/actions';
import { useCIS4mContext } from '@cistec/common_web/modules/CIS4m/context';
import { valueToBoolean } from '@cistec/common_web/modules/CIS4m/utils/data';
import { useDispatch } from 'react-redux';
import { useText } from '@cistec/common_web/utils/intlUtils';
import { createFieldPath } from 'App/components/eCheckin/utils';

const secondContactPersonFieldPathModifier: FieldPathModifier = fieldPath => {
    return `second${fieldPath}`;
};

export const KontaktPerson = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATH_KEINE_ANGABEN = createFieldPath(path, 'keineAngaben');
    const PATH_PRIORTIY_FIRST = createFieldPath(path, 'priority');
    const PATH_PRIORTIY_SECOND = createFieldPath(path, 'secondpriority');

    const dispatch = useDispatch<any>();

    const { formId } = useCIS4mContext();
    const formData = useCIS4mData();
    const keineAngaben = _.get(formData, PATH_KEINE_ANGABEN) === '1';
    const priorityFirst = _.get(formData, PATH_PRIORTIY_FIRST) === '1';
    const prioritySecond = _.get(formData, PATH_PRIORTIY_SECOND) === '1';

    const [priorities, setPriorities] = useState([priorityFirst, prioritySecond]);

    useEffect(() => {
        // Bit of a nasty way to make sure only one contact person is selected for priority
        if (priorityFirst && prioritySecond) {
            if (priorities[0]) {
                dispatch(actionRemoveFromCIS4mDataObject(formId, PATH_PRIORTIY_FIRST));
            } else if (priorities[1]) {
                dispatch(actionRemoveFromCIS4mDataObject(formId, PATH_PRIORTIY_SECOND));
            }
        }
        setPriorities([priorityFirst, prioritySecond]);
    }, [priorityFirst, prioritySecond]);

    const hideContactPersons = keineAngaben;

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox label={textMap.keineAngaben} path={PATH_KEINE_ANGABEN} parseValue={valueToBoolean} />
            <CIS4mBlock hidden={hideContactPersons}>
                <h4>1. Kontaktperson</h4>
                <KontaktPersonBlock basePath={path} required={true} />
                <h4>2. Kontaktperson</h4>
                <KontaktPersonBlock basePath={path} fieldPathModifier={secondContactPersonFieldPathModifier} />
            </CIS4mBlock>
        </ECheckinSection>
    );
});

KontaktPerson.displayName = 'KontaktPerson';

export default KontaktPerson;
